export default __webpack_public_path__ + "static/media/about.abcc34b0.jpg";